import React, { useCallback, useState } from 'react';

import SmallButtonStyled from '../../../components/Buttons/SmallButtonStyled';
import { ItemWrap, MainLine, Info, LinkStyled } from '../styledComponents';
import ConfirmationModal from '../../../components/ConfirmationModal';
import { useReloadPartners } from '../context';
import doFetch from '../../../api/doFetch';

export default function ({ partner }) {
  const reloadPartners = useReloadPartners();

  const [isOpenConfirm, setIsOpenConfirmModal] = useState(false);

  const toggleModal = useCallback(() => setIsOpenConfirmModal(!isOpenConfirm), [isOpenConfirm]);

  const handleDelete = useCallback(async () => {
    const url = `/lotlenz/partners/${partner.id}`;
    await doFetch(url, { method: 'DELETE' });

    reloadPartners();
  }, [partner, reloadPartners]);

  return (
    <ItemWrap>
      <MainLine>
        <div>
          <LinkStyled to={`/partners/${partner.id}`}>{partner.name}</LinkStyled>
        </div>
        <div>
          <Info>
            Rate limit: <b>{partner.rateLimit ? ` ${partner.rateLimit} req/min` : ' - '}</b>
          </Info>
          <SmallButtonStyled className='btn' onClick={toggleModal}>
            Delete
          </SmallButtonStyled>
        </div>
      </MainLine>
      <ConfirmationModal
        title={'REMOVE PARTNER'}
        text={
          'The partner will lose access to the system. Their data and statistics will be retained.'
        }
        isOpen={isOpenConfirm}
        toggleHandler={toggleModal}
        confirmAction={handleDelete}
      />
    </ItemWrap>
  );
}
